import HowToHeader from '../HowToHeader';
import HowToStep from '../HowToStep';

// Images
import step1Img from './Step 1 Image.png';
import step2Img from './Step 2 Image.png';
import step3FirstImg from './Step 3 Image.png';
import step3SecondImg from './Step 3 (2) Image.png';
import step4Img from './Step 4 Image.png';
import step5Img from './Step 5 Image.png';

// Header
const headerText = `Forgot your Password?`;

// Steps
const step1Text = `Click “Forgot password?” under the Log In button.`;
const step2Text = `Enter email address you used while setting up your account.`;
const step3Text = `Answer your three security questions. Be sure answers match exactly as they were entered when
                    you set up these questions, including letter case.`;
const step4Text = `Go to your email to get your temporary password. Look for a new email with the subject
                    “Password reset from the City of Chicago” that looks like the one below.`;
const step5Text = `Click “Profile, Identity, Account Settings” tab in the left navigation within your Account Dashboard.`;
const step6Text = `Change your password in the “Account Security” dropdown. Password must be 8-20 characters
                    and contain at least one upper-case letter, one lower-case letter, one number, and one of the
                    following special characters: @#$%. It cannot contain any other special characters.`;

const ReuploadingInformation = () => {
  return (
    <>
      <HowToHeader titleText={headerText} />
      <HowToStep stepNumber={1} content={step1Text} imgSrc={step1Img} />
      <HowToStep stepNumber={2} content={step2Text} imgSrc={step2Img} />
      <HowToStep stepNumber={3} content={step3Text} imgSrc={step3FirstImg} />
      <p>
        Once this information has been entered and verified for a match, you
        will see a message telling you to go to your email to obtain a temporary
        password.
      </p>
      <div className='text-center'>
        <img className='img-fluid' src={step3SecondImg} alt='Step 3' />
      </div>
      <HowToStep stepNumber={4} content={step4Text} imgSrc={step4Img} />
      <HowToStep stepNumber={5} content={step5Text} imgSrc={step5Img} />
      <HowToStep stepNumber={6} content={step6Text} />
    </>
  );
};

export default ReuploadingInformation;
